module.exports = __webpack_public_path__ + "static/media/wifi.b213756a.svg";